import { AppBar, Box, AppBarProps, BoxProps } from "@mui/material";
import { styled } from "@mui/material/styles";
import { breakpoints } from "../../styles/breakpoints";

export const Container = styled(Box)(() => ({
  display: "flex",
  maxHeight: "4rem",
}));

export const StyledAppBar = styled(AppBar)<AppBarProps>(() => ({
  backgroundImage: "var(--color-gradient-primary)",
  padding: "var(--space-xs)",
  backdropFilter: "blur(0px)",
}));

export const LogoContainer = styled("div")({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "center",
  gap: "var(--space-2xl)",

  [`@media (max-width: ${breakpoints.breakpointSmExtra})`]: {
    "& h4": {
      display: "none",
    },
  },
});

export const Logo = styled("img")({
  width: "3rem",
});

export const RightActionsContainer = styled(Box)<BoxProps>({
  display: "flex",
  gap: "var(--space-md)",
  marginLeft: "auto",
});

export const MainContent = styled(Box)({
  padding: 0,
  margin: 0,
});
